import {getAllEntitiesApply, selectManyByPredicate, UIEntitiesRef} from '@ngneat/elf-entities';
import {select} from '@ngneat/elf';

import {issuesStore} from '@store/operations/issues/issues.store';
import {getIssuesDataSource} from '@store/operations/issues/issues.requests';

export class IssueQuery {
  store = issuesStore;

  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  issues$ = getIssuesDataSource.data$();
  selectedIssues$ = this.store.pipe(
    selectManyByPredicate((issueUi) => issueUi.selected, {pluck: 'id', ref: UIEntitiesRef}),
  );

  get totalRows() {
    return this.store.getValue().pagination.total;
  }

  get selectedIssues() {
    return this.store.query(getAllEntitiesApply({
      mapEntity: (e) => e.id,
      filterEntity: (e) => e.selected,
      ref: UIEntitiesRef,
    }));
  }

}

export const issuesQuery = new IssueQuery();
